import { useEffect, useState } from "react"

const useQuestionEvent = (examData) => {
    const [questionList, setQuestionList] = useState([])

    // 백엔드 데이터가 왔을 때, 해당 값으로 State 초기화
    useEffect(() => {
        if (examData) {
            const questionData = examData?.data?.question

            const tmpList = []
            questionData.forEach(elem => {
                tmpList.push(elem)
            })
            setQuestionList(tmpList)
        }
    }, [examData])


    // ===== 지문 관련 이벤트 =====

    const setProblem = (e, index) => {
        const preList = [...questionList]
        const elemObj = { ...preList[index] }
        const value = e.target.value

        elemObj.problem = value
        preList[index] = elemObj
        setQuestionList(preList)
    }

    const createQuestionEvent = () => {
        const preList = [...questionList]
        const tmpObj = {
            "problem": "",
            "choice": [],
            "answer": null,
            "point": null
        }

        preList.push(tmpObj)
        setQuestionList(preList)
    }

    const deleteQuestionEvent = (index) => {
        const preList = [...questionList]

        preList.splice(index, 1)
        setQuestionList(preList)
    }

    const upperQuestionEvent = (index) => {
        const preList = [...questionList]

        if (index > 0) {
            let tmp = preList[index - 1]
            preList[index - 1] = preList[index]
            preList[index] = tmp
        }
        setQuestionList(preList)
    }

    const downQuestionEvent = (index) => {
        const preList = [...questionList]

        if (index < preList.length - 1) {
            let tmp = preList[index + 1]
            preList[index + 1] = preList[index]
            preList[index] = tmp
        }
        setQuestionList(preList)
    }

    // 선다 관련 이벤트

    const setChoice = (e, index, choiceIndex) => {
        const preList = [...questionList]
        const elemObj = { ...preList[index] }
        const choiceList = [...elemObj.choice]
        const value = e.target.value

        choiceList[choiceIndex] = value
        elemObj.choice = choiceList
        preList[index] = elemObj
        setQuestionList(preList)
    }

    const createChoiceEvent = (index) => {
        const preList = [...questionList]
        const elemObj = { ...preList[index] }
        console.log(elemObj.choice)
        const choiceList = [...elemObj.choice]

        choiceList.push("")

        elemObj.choice = choiceList
        preList[index] = elemObj
        setQuestionList(preList)
    }

    const deleteChoiceEvent = (index, choiceIndex) => {
        const preList = [...questionList]
        const elemObj = { ...preList[index] }
        const choiceList = [...elemObj.choice]

        choiceList.splice(choiceIndex, 1)
        if (elemObj.answer === choiceIndex) elemObj.answer = null

        elemObj.choice = choiceList
        preList[index] = elemObj
        setQuestionList(preList)
    }

    const upperChoiceEvent = (index, choiceIndex) => {
        const preList = [...questionList]
        const elemObj = { ...preList[index] }
        const choiceList = [...elemObj.choice]

        if (choiceIndex > 0) {
            let tmp = choiceList[choiceIndex - 1]
            choiceList[choiceIndex - 1] = choiceList[choiceIndex]
            choiceList[choiceIndex] = tmp

            if (elemObj.answer == choiceIndex) elemObj.answer -= 1
            else if (elemObj.answer == choiceIndex - 1) elemObj.answer += 1
        }

        elemObj.choice = choiceList
        preList[index] = elemObj
        setQuestionList(preList)
    }

    const downChoiceEvent = (index, choiceIndex) => {
        const preList = [...questionList]
        const elemObj = { ...preList[index] }
        const choiceList = [...elemObj.choice]

        if (choiceIndex < choiceList.length - 1) {
            let tmp = choiceList[choiceIndex + 1]
            choiceList[choiceIndex + 1] = choiceList[choiceIndex]
            choiceList[choiceIndex] = tmp

            if (elemObj.answer == choiceIndex) elemObj.answer += 1
            else if (elemObj.answer == choiceIndex + 1) elemObj.answer -= 1
        }

        elemObj.choice = choiceList
        preList[index] = elemObj
        setQuestionList(preList)
    }

    // 정답 입력 이벤트
    const setAsnwerEvent = (index, choiceIndex) => {
        const preList = [...questionList]
        const elemObj = { ...preList[index] }

        elemObj.answer = choiceIndex

        preList[index] = elemObj
        setQuestionList(preList)
    }

    // 점수 입력 이벤트
    const setPointEvent = (e, index) => {
        const preList = [...questionList]
        const elemObj = { ...preList[index] }
        const value = parseInt(e.target.value)

        elemObj.point = value
        preList[index] = elemObj
        setQuestionList(preList)
    }

    return [
        questionList,
        setProblem, createQuestionEvent, deleteQuestionEvent, upperQuestionEvent, downQuestionEvent,
        setChoice, createChoiceEvent, deleteChoiceEvent, upperChoiceEvent, downChoiceEvent,
        setAsnwerEvent, setPointEvent
    ]
}

export default useQuestionEvent